import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { PipeModule } from '../pipes';

const modules: Array<Type<any>> = [
	IonicModule,
	CommonModule,
	FormsModule,
	ReactiveFormsModule,
	FormlyMaterialModule,
	PipeModule,
];
const components: Array<Type<any>> = [
];

@NgModule({
	imports: [...modules],
	exports: [...modules, ...components],
	declarations: components
})
export class SharedComponentsModule { }